import loadModuleOnElement from "../utils/loadModuleOnElement";

const loader = () => import("./videoPlayer");

export default function videoLoader(context) {
    loadModuleOnElement(".js-show-video", loader, context);
    return context;
}
